import * as yup from 'yup';

import {validateEmail} from '../../tools/yup-validators.functions';

export const subscribePromosModalValidation = yup.object({
    emailAddress: validateEmail(),
});
